export interface WalkthroughContentDto {
  title: string;
  html: string;
}
